import React, {Component} from 'react'
import {Box} from 'reactjs-admin-lte'
import {Modal,Nav,NavItem,ButtonGroup,Button,DropdownButton,MenuItem,Pagination,FormGroup,Row,Col,Form,Popover,OverlayTrigger} from 'react-bootstrap'
import Select from 'react-select'
import FontAwsome from 'react-fontawesome'
import WorkdocStore from '../../stores/WorkdocStore';
// import Lightbox from 'react-images-extended';
import IframeModal from 'component/element/IframeModal'
import ConfirmPopup from 'component/element/ConfirmPopup'
import './WorkDoc.css'
import axios from "axios"
import FileSaver from 'file-saver'
import { Checkbox, Radio } from 'react-icheck'
import CKAutocomplete from 'component/element/CKAutocomplete'
import {connect} from 'react-redux'
import _ from 'lodash'
import DNDSortImg from './DNDSortImg'
import NOIMG from 'asset/img/no_image.jpg'
import Moment from 'moment'
import Viewer from 'react-viewer'
import $ from 'jquery'
import 'react-viewer/dist/index.css';

var MobileDetect = require('mobile-detect')
var NotificationSystem = require('react-notification-system');

class WorkDocAttachmentDoc extends Component {

  constructor(...args){
    super(...args)
    this.state = {
      option:[],
      newOption:[],
      defaultOption:"",
      defaultTitle:"",
      data:[],
      allData:[],
      currentImage: 0,
      lightboxIsOpen: false,
      images:[],
      loading:true,    
      checkedImg:[],
      checkedImgAll:false,
      showImgChangeGroup:false,
      to_cat:'',
      isAction:undefined,
      showDel:false,
      apiDel:undefined,
      fromDel:undefined,
      showImgSetting:false,
      showDownloadConfig:false,
      fileConfig:'original',
      defaultRows:'All',
      totalPage:1,
      activePage:1,
      showBtn:false,
      to_work:this.props.workNo,
      worklist:[],
      isLeftPrint:false,
      showSortImg:false,
      imgPerPage:4,
      sortimg_itemlist:[],
      sortimg_backup_itemlist:[],
      darg_id:null,
      printHistoryList:[],
      printHistory:''
    }
    this.focusInput = ''
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    if(this.props.workNo!==''){
      if (this.props.loadFirst)
        this.loadData(this.props.workNo)
    }
  }

  componentWillReceiveProps(newProps){
    if(newProps.workNo!==''){
      //this.loadData(newProps.workNo)
    }
  }

  loadData(workNo){
    
    let {defaultOption,defaultTitle} = this.state
    let option = []
    
    WorkdocStore.loadAttachment(workNo,(result)=> {
      result.data.list.forEach((element,index)=> {
        if (index===0) {
          defaultOption = element.cat
          defaultTitle = element.title
        }

        option.push({
          label: element.title,
          value: element.cat
        })
      })
      this.setState({option:option,defaultOption:defaultOption,to_cat:defaultOption,defaultTitle:defaultTitle,checkedImgAll:false,showImgSetting:false})
      this.loadFup(defaultOption)
    })
  }

  loadSimilarWork(workNo) {
    WorkdocStore.loadSimilarWork(workNo,(result)=>{
      if (result.data.length===0)
        this.setState({worklist:[{label:workNo,value:workNo}]})
      else {
        let worklist = []
        result.data.forEach((item,index)=>{
          worklist.push({
            label:item.label,
            value:item.value,
          })
        })
        this.setState({worklist:worklist,showImgChangeGroup:true})
      }
    })
  }

  loadFup(defaultOption,onImageUpload) {
    let {defaultRows,isLeftPrint} = this.state
    if (isLeftPrint) {
      this.loadImagesLeftPrint(defaultOption,onImageUpload)
    } else {
      WorkdocStore.loadFup(this.props.workNo,defaultOption,(result)=> {
        let checkedImg = []
        let data = []
        let totalPage = 1
        checkedImg = result.data.files.map((item,index)=>{
          return false
        })
        if (defaultRows==='All') {
          data = result.data.files
        } else {
          result.data.files.forEach((item,index)=>{
            if (index<defaultRows) {
              data.push(item)
            }  
          })
          totalPage = result.data.files.length / defaultRows
          totalPage = Math.ceil(totalPage)
        }
        this.setState({activePage:1,totalPage:totalPage,allData:result.data.files,data:data,loading:false,checkedImg:checkedImg,checkedImgAll:false})
        if(result.data.files.length>0 && onImageUpload!==undefined){
          onImageUpload()
        }
      })
    }    
  }

  loadImagesLeftPrint(defaultOption,onImageUpload) {
    let {defaultRows} = this.state
    WorkdocStore.loadImagesLeftPrint(this.props.workNo,defaultOption,(result)=> {
      let checkedImg = []
      let data = []
      let totalPage = 1
      checkedImg = result.data.map((item,index)=>{
        return false
      })
      if (defaultRows==='All') {
        data = result.data
      } else {
        result.data.forEach((item,index)=>{
          if (index<defaultRows) {
            data.push(item)
          }  
        })
        totalPage = result.data.length / defaultRows
        totalPage = Math.ceil(totalPage)
      }
      this.setState({activePage:1,totalPage:totalPage,allData:result.data,data:data,loading:false,checkedImg:checkedImg,checkedImgAll:false})
      if(result.data.length>0 && onImageUpload!==undefined){
        onImageUpload()
      }
    })  
  }

  onDropdownChange(e) {
    this.setState({defaultOption:e.value,loading:true,checkedImgAll:false,showImgSetting:false})
    this.loadFup(e.value)

    if(this.props.onCatChange!==undefined){
      this.props.onCatChange(e.value)
    }
  }

  onDropdownFocus(){    

  }

  onNavSelect(value){
    this.setState({defaultOption:value,loading:true})
    this.loadFup(value)

    if(this.props.onCatChange!==undefined){
      this.props.onCatChange(value)
    }
  }

  onDDSelect(index){
    let {option} = this.state
    this.setState({defaultOption:option[index].value,defaultTitle:option[index].label,loading:true})
    this.loadFup(option[index].value)

    if(this.props.onCatChange!==undefined){
      this.props.onCatChange(option[index].value)
    }
  }

  onImgSettingClick() {
    let {allData,checkedImg} = this.state
    let {messages} = this.props
    let items = allData.find((item,index)=>{
      return checkedImg[index]
    })
    let postData = {wo:this.props.workNo,thumb_url:items.thumbnailUrl}
    checkedImg = checkedImg.map((item,index)=>{
      item = false
      return item
    })
    WorkdocStore.workPhotoThumb(postData,(result)=>{
      if (result.status==='OK') {
        this._notificationSystem.addNotification({
          title: messages['Notice'],
          message: messages['Save Successfully'],
          level: 'info',
          position: 'tc',        
        });
        this.setState({showImgSetting:false,checkedImg:checkedImg})
      }
    },()=>{
      this._notificationSystem.addNotification({
        title: messages['Notice'],
        message: messages['Save Failed']+' ' + this.props.workNo + ' ',
        level: 'error',
        position: 'tc',        
      });
      this.setState({showImgSetting:false,checkedImg:checkedImg})
    })
  }

  renderDropdown() {
    let {messages,mode} = this.props
    let {option,defaultOption,defaultTitle,checkedImgAll} = this.state
    let md = new MobileDetect(window.navigator.userAgent);
    if(md.is('iOS') || md.is("AndroidOS")){
      return(
        <Form inline>
          <FormGroup>
            <ButtonGroup className='dd-attachement-option'>
              <DropdownButton            
                bsSize="large"
                title={defaultTitle}
                id="dropdown-size-large"
                onSelect={this.onDDSelect.bind(this)}
              >
                {option.map((item,index)=>(
                  <MenuItem key={index} eventKey={index}>{item.label}</MenuItem>  
                ))}
              </DropdownButton>
            </ButtonGroup>
          </FormGroup>
          &nbsp;
          {mode===''?
          <FormGroup>
            {this.renderButtonChangeGroup()}
          </FormGroup> 
          :''} 
        </Form>  
      )
    }else{
      return (
        <Form inline>
          <FormGroup style={{marginBottom:'0'}}>
            <Select            
              clearable={false}
              value={defaultOption}
              options={option}
              onFocus={this.onDropdownFocus.bind(this)}
              onChange={this.onDropdownChange.bind(this)}
              style={{width:'350px'}}
            >
            </Select>
          </FormGroup> 
          &nbsp;
          <FormGroup style={{marginBottom:'0'}}>
            <Checkbox
                  onChange={this.onCheckAllChange.bind(this)}
                  checked={checkedImgAll}
                  checkboxClass="icheckbox_square-blue"
                  increaseArea="20%"
                  label={' '+messages['Select All']}
                >
            </Checkbox>
          </FormGroup>
          &nbsp;
          {mode===''?
          <FormGroup style={{marginBottom:'0'}}>
            {this.renderButtonChangeGroup()}
          </FormGroup>  
          :''} 
        </Form>
      )
    }
      
  }

  renderButtonChangeGroup() {
    let {checkedImg,showImgSetting} = this.state
    let {messages} = this.props
    let checkedImgTrue = true
    let num = 0
    checkedImg.forEach(function(item,index) {
      if (item) {
        checkedImgTrue = false
        num++
      }  
    })
    return(
      <div>
        <Button bsSize='sm' bsStyle='primary' style={{display:checkedImgTrue?'none':''}} onClick={this.onChangeGruopClick.bind(this,'change')}><FontAwsome name='exchange' />&nbsp;{messages['Change']}</Button>
        &nbsp;
        <Button bsSize='sm' bsStyle='success' style={{display:checkedImgTrue?'none':''}} onClick={this.onChangeGruopClick.bind(this,'copy')}><FontAwsome name='copy' />&nbsp;{messages['Copy']}</Button>
        &nbsp;
        {num<=8
        ?
        <DropdownButton         
          style={{display:checkedImgTrue?'none':''}}   
          title={(<span><FontAwsome name='download' />&nbsp;{messages['Download']}</span>)}
          id="dropdown-img-download"
          onSelect={this.onImgDownloadSelect.bind(this)}
        >
          <MenuItem eventKey={'zip'}><FontAwsome name='file-archive-o' /> {messages['Download zip']}</MenuItem>  
          <MenuItem eventKey={'file'}><FontAwsome name='file-image-o' /> {messages['Download file']}</MenuItem>  
        </DropdownButton>
        :
        <Button bsSize='sm' bsStyle='default' style={{display:checkedImgTrue?'none':''}} onClick={this.onDownloadClick.bind(this)}><FontAwsome name='download' />&nbsp;{messages['Download']}</Button>}
        &nbsp;
        <Button bsSize='sm' bsStyle='danger' style={{display:checkedImgTrue?'none':''}} onClick={()=>this.setState({showDel:true,fromDel:'out'})}><FontAwsome name='trash' />&nbsp;{messages['Delete']}</Button>
        &nbsp;
        <Button bsSize='sm' bsStyle='default' style={{display:showImgSetting?'':'none'}} onClick={this.onImgSettingClick.bind(this)}><FontAwsome name='gear' />&nbsp;{messages['Set As Car']}</Button>
        &nbsp;
        {num>0?<span>เลือกไว้ {num} รูป</span>:''}
      </div>
    )
  }

  onChangeGruopClick(action,e) {
    let {option} = this.state
    let new_option = []
    let check_first = true
    let to_cat = ''

    option.forEach(function(item,index) {
      // if (defaultOption!==item.value) {
        if (check_first)
          to_cat = item.value

        new_option.push(item)
        check_first = false
      // }
    })
    this.setState({isAction:action,to_cat:to_cat,new_option:new_option})
    this.loadSimilarWork(this.props.workNo)
  }

  onChangeGruopSaveClick(to_cat,e) {
    let {checkedImg,allData,defaultOption,isAction} = this.state
    let files = []
    allData.forEach((item,index)=>{
      if(checkedImg[index]){
        files.push(item)
      }      
    })

    this.setState({loading:true})
    let postData = {wo:this.props.workNo,to_wo:this.state.to_work,from_cat:defaultOption,to_cat:to_cat,files:files} 
    if (isAction==='change') {
      WorkdocStore.saveAttachmentTransfer(postData,(result) => {
        this.setState({isAction:undefined,showImgChangeGroup:false,loading:false,new_option:[]})
        if (result.status==='OK') {
          this.loadData(this.props.workNo)
        }
      })
    } else if (isAction==='copy') {
      WorkdocStore.saveAttachmentCopy(postData,(result) => {
        this.setState({isAction:undefined,showImgChangeGroup:false,loading:false,new_option:[]})
        if (result.status==='OK') {
          this.loadData(this.props.workNo)
        }
      })
    } 
  }

  onImgDownloadSelect(download_type) {
    this.onDownloadClick(download_type)
  }

  onDownloadClick(download_type='zip'){
    let {allData,checkedImg,defaultOption} = this.state
    const download =  (item)=>{
      axios({
          url: item.url+'?dl=1',
          method: 'GET',
          responseType: 'blob', // important
          withCredentials: true
        }).then((response) => {
          FileSaver.saveAs(new Blob([response.data]), item.name);
        });
    }
    const postData = allData.reduce((rresult,item,index)=>{
      if (checkedImg[index]) {
        rresult.push({name:item.name})
      }
      return rresult
    },[])
    if(postData.length>8||download_type==='zip'){
      WorkdocStore.downloadAttachment(this.props.workNo,defaultOption,postData,(response)=>{
        const fileName = this.props.workNo.replace("/", "_")+'_'+defaultOption+'.zip';
        FileSaver.saveAs(new Blob([response.data]), fileName);
      },(error)=>{
        //Download Error
      })
    }else{
      allData.forEach( (item,index)=>{  
        if (checkedImg[index])     
          download(item)            
      })
    }
  }

  onDropdownGroupChange(e) {
    this.setState({to_cat:e.value})
  }

  onWorkChange(e) {
    this.setState({to_work:e.value})
  }

  renderModalChangeGroup() {
    let {showImgChangeGroup,checkedImg,option,new_option,to_cat,defaultOption,isAction} = this.state
    let checkedImgTrue = []
    let {messages} = this.props
    checkedImg.forEach(function(item,index) {
      if (item)
        checkedImgTrue.push(item)
    })

    let currentGroup = ''
    option.forEach(function(item,index) {
      if (item.value===defaultOption) {
        currentGroup = item.label
      }
    })

    return(
        <Modal show={showImgChangeGroup} onHide={()=>this.setState({isAction:undefined,showImgChangeGroup:false,new_option:[]})}>
          <Modal.Header closeButton>
            <Modal.Title>{(isAction==='change'?messages['Change']:messages['Copy'])+' ('+checkedImgTrue.length+' '+messages['File']+')'}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form horizontal>
              <FormGroup>
                <Col sm={1}></Col>
                <Col sm={3}>
                  {isAction==='change'?messages['Move From']:messages['Copy From']}
                </Col>
                <Col sm={5}>
                  {currentGroup}
                </Col>
              </FormGroup>
              <FormGroup>
                <Col sm={1}></Col>
                <Col sm={3}>
                {isAction==='change'?messages['Choose New Category']:messages['Go To']}
                </Col>
                <Col sm={5}>
                  <Select            
                    clearable={false}
                    value={to_cat}
                    options={new_option}
                    onChange={this.onDropdownGroupChange.bind(this)}
                  />
                </Col>
              </FormGroup>
              <FormGroup>
                <Col sm={1}></Col>
                <Col sm={3}>
                เลือกใบจ็อบ
                </Col>
                <Col sm={8}>
                  <Select            
                    clearable={false}
                    value={this.state.to_work}
                    options={this.state.worklist}
                    onChange={this.onWorkChange.bind(this)}
                  />
                </Col>
              </FormGroup>
            </Form>  
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle={isAction==='change'?'primary':'success'} onClick={this.onChangeGruopSaveClick.bind(this,to_cat)}><FontAwsome name={isAction==='change'?'exchange':'copy'} />&nbsp;{isAction==='change'?messages['Change']:messages['Copy']}</Button>
            <Button onClick={()=>this.setState({isAction:undefined,showImgChangeGroup:false,new_option:[]})}><FontAwsome name='close' />&nbsp;{messages['Close']}</Button>
          </Modal.Footer>
        </Modal>
    )
  }

  renderX(){
      let {option} = this.state
      return(
        <div>
          
          
            <Nav bsStyle="tabs" stacked activeKey={1} onSelect={this.onNavSelect.bind(this)}>
              {option.map((item,index)=>(
                  <NavItem key={index} eventKey={item.value} >
                    {item.label}
                  </NavItem>
              ))}          
            </Nav>
          
        </div>
      )
    
  }

  // onImgClick(item,index,type,e) {
  //   let {images,allData} = this.state
  //   if (type==='image') {
  //     allData.forEach(element => {
  //       images.push({
  //         src: element.url,
  //         thumbnail: element.thumbnailUrl,
  //         srcset: [
  //           element.url,
  //         ],
  //         caption: element.name
  //       })
  //     })  
  //     this.setState({currentImage:index,lightboxIsOpen:true,images:images})
  //   } else {
  //     window.open(item.url, '_blank');
  //   }
  // }

  onImgClick(item,index,type,e) {
    let {images,allData} = this.state
    if (type==='image') {
      allData.forEach(element => {                
        images.push({
          src: item.name===element.name?item.url:element.thumbnailUrl,
          original: element.url,
          thumbnail: element.thumbnailUrl,
          srcset: [
            element.url,
          ],
          caption: element.name,
          alt:element.name
        })
      })  
      this.setState({currentImage:index,lightboxIsOpen:true,images:images},()=>{
        $(function() {
          $("ul.react-viewer-toolbar").find("[data-key='check']").removeClass('react-viewer-btn');
          $("ul.react-viewer-toolbar").find("[data-key='delete']").removeClass('react-viewer-btn');
          $("ul.react-viewer-toolbar").find("[data-key='check']").addClass('light-checkbox');
          $("ul.react-viewer-toolbar").find("[data-key='delete']").addClass('light-delete');
        });
      })
    } else {
      window.open(item.url, '_blank');
    }
  }

  onUpdateCurrentImage(img,number) {
    let {images} = this.state
    if (img.original){ 
      img.src = img.original;
      images[number] = img;
    }
   
    this.setState({currentImage:number,images:images})
  }

  onClickImage() {
    let {allData} = this.state
    if (this.state.currentImage === 0) {
      this.onClickNext()
    } else if (this.state.currentImage === allData.length-1) {
      this.onClickPrevious()
    } else {
      this.onClickNext()
    }
  }

  onClickThumbnail(index) {
    this.setState({currentImage:index})
  }

  onClickNext() {
    this.setState({
      currentImage: this.state.currentImage + 1,
    });
  }

  onClickPrevious() {
    this.setState({
      currentImage: this.state.currentImage - 1,
    });
  }

  onCloseLightbox() {
    this.setState({
      currentImage: 0,
      lightboxIsOpen: false,
      images: []
    });
  }

  onCheckChange(item,index) {
    let {checkedImg,checkedImgAll,showImgSetting,data,defaultOption} = this.state
    if (checkedImg[index])
      checkedImgAll = false

    checkedImg[index] = !checkedImg[index]
    let _check = 0
    let _checkedImgAll = true
    checkedImg.forEach((item,index)=>{
      if (item)
        _check++
      else
        _checkedImgAll = false
    })
    if (_check===1)
      showImgSetting = true
    else
      showImgSetting = false
    
    if (_checkedImgAll)
      checkedImgAll = true
    else
      checkedImgAll = false  
    this.setState({checkedImg:checkedImg,checkedImgAll:checkedImgAll,showImgSetting:showImgSetting})
    if (this.props.onImgCheck!==undefined) {
      let imgPO = []
      checkedImg.forEach((item,index)=>{
        if (item)
          imgPO.push(data[index])
      })
      this.props.onImgCheck(imgPO,defaultOption)
    }
  }

  onCheckAllChange() {
    let {checkedImgAll,checkedImg,activePage,defaultRows,defaultOption,data} = this.state
    let start = 0
    let i = 0
    if (defaultRows!=='All') {
      if (activePage>1)
        start = (activePage * defaultRows) - defaultRows
    
      
      if (start===0) 
        start = defaultRows*1
      else {
        start = (start*1)+(defaultRows*1)
        i = start - (defaultRows*1)
      }
    }  
    
    let newCheckedImg = []
    if (checkedImg.length>0) {
      checkedImg.forEach(function(item,index) {
        if (checkedImgAll) {
          newCheckedImg.push(false)
        } else {
          if (defaultRows!=='All') {
            if (index>=i&&index<start)
              newCheckedImg.push(true)
            else
              newCheckedImg.push(false)
          } else {
            newCheckedImg.push(true)    
          }   
        }  
      })
    } else {
      newCheckedImg = checkedImg
    } 

    if (checkedImgAll) {
        checkedImgAll = false
    } else {
      checkedImgAll = true
    }
    this.setState({checkedImgAll:checkedImgAll,checkedImg:newCheckedImg,showImgSetting:false})
    if (this.props.onImgCheck!==undefined) {
      let imgPO = []
      newCheckedImg.forEach((item,index)=>{
        if (item)
          imgPO.push(data[index])
      })
      this.props.onImgCheck(imgPO,defaultOption)
    }
  }

  renderImgZone() {
    let {data,checkedImg,defaultRows,activePage} = this.state
    let {messages} = this.props
    if (data.length>0) {
      return(
        data.map((item, index) => {
          let start = 0
          if (activePage>1)
            start = (activePage * defaultRows) - defaultRows
          
          index += (start*1)
          const popover = (
            <Popover 
              id="popover-trigger-hover-click" 
              title={item.name}
            >
              <div>{item.createddate}</div>
            </Popover>
          )
          const _name = (<div className='thumb-box-name'>{item.name}</div>)
          let type = 'image'
          if (item.name.indexOf('.pdf')!==-1)
            type = 'pdf'
          return(
            <Col key={index} className="col-md-15 template-download">
              <div className="thumb-box">
                <Checkbox
                  onChange={this.onCheckChange.bind(this,item,index)}
                  checked={checkedImg[index]}
                  checkboxClass="icheckbox_square-blue"
                  increaseArea="20%"
                  label=""
                >
                </Checkbox>
                <div className='thumb-box-img'>
                  <span className="preview" onClick={this.onImgClick.bind(this,item,index,type)}>
                    <a title="">
                      <img alt='' src={item.thumbnailUrl} className='img-auto-width' style={{height:(item.height>item.width?'100%':'auto')}} />
                    </a>
                  </span>
                  <div>
                    <OverlayTrigger
                      trigger={['hover', 'click']}
                      placement="bottom"
                      overlay={popover}
                    >
                      {_name}
                    </OverlayTrigger>
                  </div>
                  <div className='footer-box'>
                    {item.createddate}
                  </div>
                </div>
              </div>
            </Col>   
          )       
        })
      )    
    } else {
      return(
        <div className="text-center">
          {messages['No Image']}
        </div>
      )
    }  
  }

  onUploadClick() {
    let {defaultOption} = this.state

    let url = ''
    if (process.env.NODE_ENV === "development") {
      url = 'https://demo2.bigfix.co/okorat/fup/index.html?cat='+defaultOption+'&wo='+this.props.workNo
    } else {
      url = './fup/index.html?cat='+defaultOption+'&wo='+this.props.workNo
    }
    
    this.refs.iframe.loadUrl(url,  ()=> {
      this.loadFup(defaultOption,()=>{
        if (this.props.onImageUpload !== undefined)
          this.props.onImageUpload()        
      })        
    })
  }

  onLoadPrintHistory() {
    let {printHistoryList,defaultOption} = this.state
    WorkdocStore.loadImagesPrintHistory(defaultOption,this.props.workNo,(result)=>{
      printHistoryList = result.data.map((item,index)=>{
        return {label:(item.print_date+' ('+item.file_count+')'),value:item.bf_photo_print_id}
      })
      this.setState({printHistoryList:printHistoryList})
    })
  }

  onLoadImagesPrint(history) {
    let {defaultOption} = this.state
    WorkdocStore.loadImagesPrint(defaultOption,history,this.props.workNo,(result)=>{
      let sortimg_itemlist = []
      sortimg_itemlist = result.data.map((item,index)=>{
        item = Object.assign({seq:(index+1).toString()},item)
        return item
      })
      this.setState({sortimg_itemlist:sortimg_itemlist})
    })
  }

  onClearEmpty(itemlist) {
    let newItemlist = []
    itemlist.forEach((item,index)=>{
      if (item.thumbnailUrl!=='EMPTY')
        newItemlist.push(item)
    })
    return newItemlist
  }

  onImgPerPage(number=4) {
    this.setState({imgPerPage:number},()=>{
      let {sortimg_itemlist} = this.state
      let new_sortimg_itemlist = this.onClearEmpty(sortimg_itemlist)
      let page = Math.ceil(new_sortimg_itemlist.length/number)
      let shouldItem = page*number
      let emptyRow = shouldItem-new_sortimg_itemlist.length
      for (var i=1;i<=emptyRow;i++) {
        new_sortimg_itemlist.push({
          seq:'',createddate:'',deleteType:'',deleteUrl:'',deleteWithCredentials:'',height:'',name:'',size:'',thumbnailUrl:'EMPTY',timestamp:'',url:'',width:''
        })
        new_sortimg_itemlist[new_sortimg_itemlist.length-1].seq = (new_sortimg_itemlist.length).toString()
      }
      this.setState({sortimg_itemlist:new_sortimg_itemlist})
    })
  }

  onPrePrintClick() {
    let {allData,checkedImg,imgPerPage,sortimg_itemlist,printHistoryList} = this.state
    if (printHistoryList.length===0)
      this.onLoadPrintHistory()
    
    let files = []
    if (sortimg_itemlist.length===0) {
      allData.map((item,index)=>{
        if (checkedImg[index]) {
          let file = Object.assign({seq:(index+1).toString()},item)
          files.push(file)
        }
        return item      
      })
    } else {
      files = sortimg_itemlist
    }  
    let page = Math.ceil(files.length/imgPerPage)
    let shouldItem = page*imgPerPage
    let emptyRow = shouldItem-files.length
    for (var i=1;i<=emptyRow;i++) {
      files.push({
        seq:'',createddate:'',deleteType:'',deleteUrl:'',deleteWithCredentials:'',height:'',name:'',size:'',thumbnailUrl:'EMPTY',timestamp:'',url:'',width:''
      })
      files[files.length-1].seq = (files.length).toString()
    }
    this.setState({sortimg_itemlist:files,sortimg_backup_itemlist:files},()=>{
      this.setState({showSortImg:true})
    })
  }

  onPrintClick() {
    let {defaultOption,sortimg_itemlist,printHistoryList} = this.state
    let new_sortimg_itemlist = this.onClearEmpty(sortimg_itemlist)
    let postData = {work_no:this.props.workNo,cat_id:defaultOption,files:new_sortimg_itemlist}
    let that = this
    this.setState({loading:true})
    WorkdocStore.saveWorkdocPhotoPrint(postData,function(result) {
      let newItem = []
      if (printHistoryList.findIndex(x=>x.value==='latest')!==-1)
        newItem = [{label:'เลือกล่าสุด',value:'latest'}]

      newItem.push({label:(Moment().format("YYYY-MM-DD HH:mm:ss")+' ('+new_sortimg_itemlist.length+')'),value:result.id})
      printHistoryList.forEach((item,index)=>{
        if (item.value!=='latest')
          newItem.push(item)
      })
      that.setState({loading:false,printHistoryList:newItem})
      let url = ''
      if (process.env.NODE_ENV === "development") {
        url = 'https://demo2.bigfix.co/korat/pdf/?file=photo&wo='+that.props.workNo+'&cat='+defaultOption+'&pid='+result.id+'&ipp='+that.state.imgPerPage
      } else {
        url = './pdf/?file=photo&wo='+that.props.workNo+'&cat='+defaultOption+'&pid='+result.id+'&ipp='+that.state.imgPerPage
      }    
      
      that.refs.iframePrint.loadUrl(url)
    },function(error){
      that.setState({loading:false})
    })
  }

  getComponentArray() {
    let {checkedImg,currentImage,allData} = this.state
    return (
      <div style={{display:'flex'}} key={0}>
                <Checkbox
                  onChange={this.onCheckChange.bind(this,{},currentImage)}
                  checked={checkedImg[currentImage]}
                  checkboxClass="icheckbox_square-blue"
                  increaseArea="20%"
                  label=""
                >
        </Checkbox>
        <div style={{position:'absolute',left:'50%'}}>
          <button style={{position:'relative',left:'-50%'}} className='btn btn-xs btn-danger' onClick={()=>this.setState({showDel:true,apiDel:allData[currentImage],fromDel:'in'})}><FontAwsome name='trash' />&nbsp;{this.props.messages['Delete']}</button>
        </div>
      </div>
    )
  }

  onConfirmDel() {
    let {apiDel,currentImage,allData,fromDel,checkedImg,defaultRows} = this.state
    if (fromDel==='in') {
      const okFunc = ()=>{
        allData.splice(currentImage,1)
        this.setState({showDel:false,apiDel:undefined,fromDel:undefined})
        this.onCloseLightbox()
      }

      const errFunc = ()=>{
        allData.splice(currentImage,1)
        this.setState({showDel:false,apiDel:undefined,fromDel:undefined})
        this.onCloseLightbox()
      }

      if(apiDel.deleteType!==undefined && apiDel.deleteType==='POST'){
        WorkdocStore.postDelImg(apiDel.deleteUrl,okFunc,errFunc)
      }else{
        WorkdocStore.delImg(apiDel.deleteUrl,okFunc,errFunc)
      }
    } else if (fromDel==='out') {
      let delIndex = []
      allData.forEach((item,index)=>{
        if (checkedImg[index]) {
          delIndex.push(index)
          if(item.deleteType!==undefined && item.deleteType==='POST'){
            WorkdocStore.postDelImg(item.deleteUrl,()=>{
              
            },()=>{
              
            })
          }else{
            WorkdocStore.delImg(item.deleteUrl,()=>{
              
            },()=>{
              
            })
          }
        }      
      })
      delIndex.forEach((item,index)=>{
        delete allData[item]
      })
      let new_all_data = allData.map((item,index)=>{
        return item
      })
      allData = new_all_data

      let data = []
      let totalPage = 1
      if (defaultRows==='All') {
        data = allData
      } else {
        allData.forEach((item,index)=>{
          if (index<defaultRows) {
            data.push(item)
          }  
        })
        totalPage = allData.length / defaultRows
        totalPage = Math.ceil(totalPage)
      }
      checkedImg = []
      checkedImg = allData.map((item,index)=>{
        return false
      })

      this.setState({showDel:false,fromDel:undefined,checkedImg:checkedImg,checkedImgAll:false,allData:allData,totalPage:totalPage,activePage:1,data:data})
    }  
  }

  renderDownloadConfig() {
    return(
      <div className='text-right'>
        <div style={{cursor:'pointer'}} onClick={this.onDownloadConfigClick.bind(this)}><FontAwsome name='gear' /></div>
      </div>
    )
  }

  onDownloadConfigChange(val) {
    this.setState({fileConfig:val})
  }

  onDownloadConfigClick() {
    WorkdocStore.loadConfigAttachment((result)=>{
      this.setState({showDownloadConfig:true,fileConfig:result.data.download_image_type})
    })
  }

  onPageSelect(page) {
    let {allData,defaultRows} = this.state
    if (defaultRows!=='All') {
      let start = 0
      let data = []
      if (page>1)
        start = (page * defaultRows) - defaultRows
      
      let i = 0
      if (start===0) 
        start = defaultRows*1
      else {
        start = (start*1)+(defaultRows*1)
        i = start - (defaultRows*1)
      }
      allData.forEach((item,index)=>{
        if (index>=i&&index<start) {
          data.push(item)
        }
      })
      this.setState({activePage:page,data:data})
    }  
  }

  onRowsPerPageChange(e) {
    let {defaultRows} = this.state
    let val = e.target.value
    defaultRows = val
    this.setState({defaultRows:defaultRows,showBtn:true})
  }

  onRowsPerPageSelect(rows) {
    let {allData} = this.state
    let data = []
    let checkedImg = []
    let totalPage = 1
    checkedImg = allData.map((item,index)=>{
      return false
    })
    if (rows!=='All') {
      allData.forEach((item,index)=>{
        if (index<rows) {
          data.push(item)
        }
      })
      totalPage = allData.length / rows
      totalPage = Math.ceil(totalPage)
    } else {
      data = allData
    }
    this.setState({activePage:1,totalPage:totalPage,defaultRows:rows,data:data,checkedImg:checkedImg,checkedImgAll:false,showBtn:false})  
  }

  onRowsPerPageKeyPress(e) {
    if (e.charCode===13) {
      e.preventDefault()

      let {defaultRows} = this.state
      defaultRows = (defaultRows===''||defaultRows===null||defaultRows===undefined||isNaN(defaultRows)?'All':defaultRows)
      this.onRowsPerPageSelect(defaultRows)
    }
  }

  onRowsPerPageClick() {
    let {defaultRows} = this.state
    defaultRows = (defaultRows===''||defaultRows===null||defaultRows===undefined||isNaN(defaultRows)?'All':defaultRows)
    this.onRowsPerPageSelect(defaultRows)
  }

  onLeftPrintChange(status) {
    this.setState({isLeftPrint:status},()=>{
      this.loadFup(this.state.defaultOption)
    })
  }

  onSaveDownloadConfigClick() {
    let {fileConfig} = this.state
    let {messages} = this.props
    let postData = {download_image_type:fileConfig}
    WorkdocStore.saveConfigAttachment(postData,(result)=>{
      this.setState({showDownloadConfig:false})
      if (result.status==='OK') {
        this._notificationSystem.addNotification({
          title: messages['Notice'],
          message: messages['Save Successfully'],
          level: 'info',
          position: 'tc',        
        });
      }
    },()=>{
      this.setState({showDownloadConfig:false})
      this._notificationSystem.addNotification({
        title: messages['Notice'],
        message: messages['Save Failed'],
        level: 'error',
        position: 'tc',        
      });
    })
  }

  renderDownloadConfigModal() {
    let {showDownloadConfig,fileConfig} = this.state
    let {messages} = this.props
    return(
      <div>
        <Modal show={showDownloadConfig} onHide={()=>this.setState({showDownloadConfig:false})}>
          <Modal.Header closeButton>
            <Modal.Title>{messages['Download Image Settings']}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form horizontal>
              <FormGroup>
                <Col sm={4}>
                  {messages['Choose File Extension']}
                </Col>
                <Col sm={8}>
                  <Radio
                    onChange={this.onDownloadConfigChange.bind(this,'original')}
                    checked={fileConfig==='original'?true:false}
                    radioClass="iradio_square-blue"
                    increaseArea="20%"
                    label={' '+messages['Original File']}
                  >
                  </Radio>
                  &nbsp;
                  <Radio
                    onChange={this.onDownloadConfigChange.bind(this,'jpg')}
                    checked={fileConfig==='jpg'?true:false}
                    radioClass="iradio_square-blue"
                    increaseArea="20%"
                    label=" jpg"
                  >
                  </Radio>
                  &nbsp;
                  <Radio
                    onChange={this.onDownloadConfigChange.bind(this,'png')}
                    checked={fileConfig==='png'?true:false}
                    radioClass="iradio_square-blue"
                    increaseArea="20%"
                    label=" png"
                  >
                  </Radio>
                </Col>
              </FormGroup>
            </Form>  
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle={'primary'} onClick={this.onSaveDownloadConfigClick.bind(this)}><FontAwsome name={'save'} />&nbsp;{messages['Save']}</Button>
            <Button onClick={()=>this.setState({showDownloadConfig:false})}><FontAwsome name={'close'} />&nbsp;{messages['Close']}</Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }

  renderColDetail(index,sindex,sitem,opacity) {
    if (sitem.thumbnailUrl==='EMPTY') {
      return(
        <img  
          onMouseEnter={()=>{this.setState({darg_id:sitem.seq})}} 
          onMouseLeave={()=>{this.setState({darg_id:null})}} 
          alt='' 
          src={NOIMG} 
          className='img-auto-width' 
          style={{height:'100%',width:'100%',visibility:'hidden'}}
        />
      )
    } else {
      return(
        <img 
          onMouseEnter={()=>{this.setState({darg_id:sitem.seq})}} 
          onMouseLeave={()=>{this.setState({darg_id:null})}} 
          alt='' 
          src={sitem.thumbnailUrl} 
          className='img-auto-width' 
          style={{opacity:opacity,height:(sitem.height>sitem.width?'-webkit-fill-available':'auto'),with:'100%'}} 
        />
      )
    }
  }

  renderSortImg() {
    let {sortimg_itemlist,imgPerPage,darg_id} = this.state
    let files_per_page = []
    let page = 0
    let seq = 0
    sortimg_itemlist.forEach((item,index)=>{
      if (index===0) {
        let file = item
        files_per_page.push({
          page:page,
          files:[file]
        })
        seq++
      } else {
        if (seq<imgPerPage) {
          let file = item
          files_per_page[page].files.push(file)
          seq++
        } else {
          page++
          seq = 1
          let file = item
          files_per_page.push({
            page:page,
            files:[file]
          })
        }
      }
    })
    if (files_per_page.length===0) {
      return(<Col md={12} className='text-center'>--ไม่มีรูปภาพ--</Col>)
    } else {
      return(
        files_per_page.map((item,index)=> {
          return(
            <Col key={index} className='text-center' md={6} style={{paddingBottom:'30px'}}>
              <div className='text-right' style={{padding:'10px',position:'absolute',right:'16px'}}>
                {index+1}/{files_per_page.length}
              </div>
              <div style={{padding:'35px 0 30px',border:'1px solid #111'}}>
                <Row>
                  {item.files.map((sitem,sindex)=>{
                    return (
                      <Col key={sindex} md={imgPerPage===9?4:6} sm={imgPerPage===9?4:6} xs={imgPerPage===9?4:6} style={{marginBottom:'10px'}}>
                        <div className={'sort-img'+(imgPerPage===9?' img-9':'')} style={{visibility:(sitem.thumbnailUrl==='EMPTY'?'hidden':'visible'),border:(sitem.thumbnailUrl==='EMPTY'?'2px dashed #ddd':(darg_id===sitem.seq?'2px dashed #428bca':'2px dashed #ddd'))}}>
                          <DNDSortImg
                            key={sindex} 
                            id={sitem.seq}
                            item={sitem}
                            moveRow={this.onMoveRow.bind(this)}
                            renderColDetail={this.renderColDetail.bind(this,index,sindex)}
                          />
                        </div>  
                      </Col>
                    )
                  })}
                </Row>  
              </div>  
            </Col>
          )
        })
      )
    }
  }

  onMoveRow(id,afterId) {
    let {sortimg_itemlist} = this.state
    var rows = _.clone(sortimg_itemlist);
    var currentRow = _.filter(rows, function (r) { return r.seq === id; })[0];
    var afterRow = _.filter(rows, function (r) { return r.seq === afterId; })[0];
    var currentRowIndex = rows.indexOf(currentRow);
    var afterRowIndex = rows.indexOf(afterRow);
    // remove the current row
    rows.splice(currentRowIndex, 1);
    // put it after
    rows.splice(afterRowIndex, 0, currentRow);
    sortimg_itemlist = rows
    this.setState({sortimg_itemlist: sortimg_itemlist});
  }

  onPrintHistoryChange(e) {
    let {printHistoryList,sortimg_backup_itemlist} = this.state
    if (e.value==='latest') {
      this.setState({sortimg_itemlist:sortimg_backup_itemlist,printHistory:e.value})
    } else {
      let newItem = []
      if (printHistoryList.findIndex(x=>x.value==='latest')===-1)
        newItem = [{label:'เลือกล่าสุด',value:'latest'}]
      
      printHistoryList.forEach((item,index)=>{
        newItem.push(item)
      })
      this.setState({printHistoryList:newItem,printHistory:e.value},()=>{
        this.onLoadImagesPrint(e.value)
      })
    }  
  }

  renderSortImgModal() {
    let {showSortImg} = this.state
    let {messages} = this.props
    return(
      <div>
        <Modal show={showSortImg} onHide={()=>this.setState({printHistory:'',imgPerPage:4,showSortImg:false,sortimg_itemlist:[]})} bsSize="large" dialogClassName="midwidth-dialog">
          <Modal.Header closeButton>
            <Modal.Title>เรียงรูปภาพก่อนปริ๊น</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <Row>
                <Col md={12}>
                  <Form inline className='text-center'>
                    <FormGroup>
                      <Button 
                        className="btn bg-maroon" 
                        onClick={this.onPrintClick.bind(this)}
                      >
                        <FontAwsome name="print" />&nbsp;{messages['Print Image']}
                      </Button>
                    </FormGroup>
                    {' '}
                    <FormGroup className='text-left'>
                      <Select
                        style={{width:'250px'}}
                        clearable={false}
                        placeholder='เลือกรายการ'
                        value={this.state.printHistory}
                        options={this.state.printHistoryList}
                        onChange={this.onPrintHistoryChange.bind(this)}
                      />
                    </FormGroup>
                  </Form>  
                </Col>
              </Row>
              <br />
              <Row>
                <Col md={4} sm={4} xs={4} className='text-center'>
                  <Button onClick={this.onImgPerPage.bind(this,4)}>4 รูปต่อหน้า</Button>
                </Col>
                <Col md={4} sm={4} xs={4} className='text-center'>
                  <Button onClick={this.onImgPerPage.bind(this,6)}>6 รูปต่อหน้า</Button>
                </Col>
                <Col md={4} sm={4} xs={4} className='text-center'>
                  <Button onClick={this.onImgPerPage.bind(this,9)}>9 รูปต่อหน้า</Button>
                </Col>
              </Row>  
              <br />
              <Row>
                {this.renderSortImg()}
              </Row>
            </div> 
          </Modal.Body>
        </Modal>
      </div>
    )  
  }

  render() {
    let {messages,mode} = this.props
    let {showBtn} = this.state
    let title = ''
    // let bsSize='default'
    let bsStyle='default'
    let md = new MobileDetect(window.navigator.userAgent);
    if(md.is('iOS') || md.is("AndroidOS")){
      title = messages['Add Image']
      //bsSize='large'
      bsStyle='success'
    }else{
      //bsSize='small'
      bsStyle='primary'
      title = messages['Add And Manage Image']
    }
    return(
      <div>
        <Box loading={this.state.loading}>
          <Box.Header>
            <Box.Title>
              <FontAwsome className="text-blue" name="archive" /> {messages['Illustration']}
            </Box.Title>
            {mode===''?
            <Box.Tools>
              <Button className='btn btn-md' bsStyle={bsStyle} onClick={this.onUploadClick.bind(this)}><FontAwsome name="plus" />&nbsp;{title}</Button>
              &nbsp;
              <Button 
                className="btn bg-maroon" 
                onClick={this.onPrePrintClick.bind(this)}
                style={{display:(this.props.showPrint===true?'':'none')}}
              >
                  <FontAwsome name="print" />&nbsp;{messages['Print Image']}
              </Button>
            </Box.Tools>
            :''}
          </Box.Header>
          <Box.Body>
            <Row>
              <Col md={10}>
                {this.renderDropdown()}
              </Col>
              {mode===''?
              <Col md={2}>
                {this.renderDownloadConfig()}
              </Col>
              :''}
            </Row>
            <Row>
              <Col md={12}>
                <hr/>
              </Col>
            </Row>
            <Row>
              <Col md={4}>
                <Form>
                  <FormGroup>
                  <Checkbox
                    onChange={this.onLeftPrintChange.bind(this,!this.state.isLeftPrint)}
                    checked={this.state.isLeftPrint}
                    checkboxClass="icheckbox_square-blue"
                    increaseArea="20%"
                    label={' แสดงเฉพาะไม่เคยพิมพ์รูป'}
                  >
                  </Checkbox>
                  </FormGroup>
                </Form>
              </Col>
              <Col md={8}>
                <div className="pull-right">
                  <Form inline>
                    <FormGroup>
                      จำนวนรูปต่อหน้า
                    </FormGroup>  
                    {' '}
                    <FormGroup>
                      <CKAutocomplete
                        width={'50px'}
                        top={'-35px'}
                        items={[{label:'25',id:25},{label:'50',id:50},{label:'75',id:75},{label:'100',id:100},{label:'All',id:'All'}]}
                        value={this.state.defaultRows}
                        onChange={this.onRowsPerPageChange.bind(this)}
                        onSelect={this.onRowsPerPageSelect.bind(this)}
                        onKeyPress={this.onRowsPerPageKeyPress.bind(this)}
                        shouldItemRender={null}
                      />
                    </FormGroup> 
                    {' '}
                    <FormGroup>
                      <Button onClick={this.onRowsPerPageClick.bind(this)} style={{display:(showBtn?'':'none')}} bsStyle='success' bsSize='sm'>OK</Button>
                    </FormGroup>
                    {' '} 
                    <FormGroup style={{lineHeight:'10px'}}>
                      <Pagination
                        prev='ก่อนหน้า'
                        next='ถัดไป'
                        first={false}
                        last={false}
                        ellipsis
                        boundaryLinks
                        items={this.state.totalPage}
                        maxButtons={5}
                        activePage={this.state.activePage}
                        onSelect={this.onPageSelect.bind(this)}
                      />
                    </FormGroup>  
                  </Form>  
                </div>
              </Col>
            </Row>
            <Row>
              {this.renderImgZone()}
            </Row>
          </Box.Body>
          <IframeModal ref='iframe' title={messages['Upload Image']} modal={true} />
          <IframeModal ref='iframePrint' title={messages['Print Document']} />
          {/* <Lightbox
            currentImage={this.state.currentImage}
            images={this.state.images}
            showThumbnails={true}
            showCloseButton={true}
            rotatable={true}
            zoomable={true}          
            isOpen={this.state.lightboxIsOpen}
            onClickImage={this.onClickImage.bind(this)}
            onClickNext={this.onClickNext.bind(this)}
            onClickPrev={this.onClickPrevious.bind(this)}
            onClickThumbnail={this.onClickThumbnail.bind(this)}
            onClose={this.onCloseLightbox.bind(this)}
            customControls={[this.getComponentArray()]}
          /> */}
          <Viewer
            zIndex={9999}
            customToolbar={(toolbars) => {
              return toolbars.concat([
                {
                  key: 'check',
                  render: 
                    <div>
                      <Checkbox
                        onChange={this.onCheckChange.bind(this,{},this.state.currentImage)}
                        checked={this.state.checkedImg[this.state.currentImage]}
                        checkboxClass="icheckbox_square-blue"
                        increaseArea="20%"
                        label=" เลือกรูปภาพ"
                      >
                      </Checkbox> 
                    </div>
                },
                {
                  key: 'delete',
                  render: <div><Button className='btn-xs btn-danger' onClick={()=>this.setState({showDel:true,apiDel:this.state.allData[this.state.currentImage],fromDel:'in'})}><FontAwsome name='trash' />&nbsp;{this.props.messages['Delete']}</Button></div>
                },
              ]);
            }}
            activeIndex={this.state.currentImage}
            visible={this.state.lightboxIsOpen}
            onClose={this.onCloseLightbox.bind(this)}
            images={this.state.images}
            onChange={this.onUpdateCurrentImage.bind(this)}
          />
          <ConfirmPopup
            show={this.state.showDel}
            onHide={()=>this.setState({showDel:false,apiDel:undefined,fromDel:undefined})}
            message={messages['Confirm Delete Image']}
            onConfirm={this.onConfirmDel.bind(this)}
            zIndex={'99999'}
          />
          {this.renderModalChangeGroup()}
        </Box>
        {this.renderDownloadConfigModal()}
        {this.renderSortImgModal()}
        <NotificationSystem ref="notificationSystem" />
      </div>
    )
  }
}

WorkDocAttachmentDoc.defaultProps = {
  showPrint:true,
  mode:'',
  loadFirst:true
}
export default WorkDocAttachmentDoc = connect(
  (state) => ({messages: state.message.view.workdoc.WorkDocAttachmentDoc}),null,null,{withRef:true}
)(WorkDocAttachmentDoc);


// WEBPACK FOOTER //
// ./src/view/workdoc/WorkDocAttachmentDoc.js